import qs from '../../utilities/query-string';
import React, { Component } from 'react';
import {connect} from "react-redux";
import { withRouter } from 'react-router-dom';
import ReportComponent from "./report-component";
import {changeReportUrl } from "./report-action-creators";


class ReportContainer extends Component {

  constructor(props) {
    super(props);
    const reportUrl = qs.parse(this.props.location.search).reportUrl;
    this.props.changeReportUrl(reportUrl);
  }

  render() {
    return <ReportComponent {...this.props} />;
  }
}

const mapStateToProps = state => ({

  filters: state.filters.filters,
  filtersToSend: state.filters.filtersToSend,
  reportUrl: state.report.reportUrl
});


const mapDispatchToProps = dispatch => ({
  changeReportUrl: reportUrl => dispatch(changeReportUrl(reportUrl))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ReportContainer));


// WEBPACK FOOTER //
// ./src/modules/report/report-container.js